// page.tsx
"use client";

import { useState, Suspense, lazy } from "react";
import LockScreen from "../../Components/Lockscreen";
import "./Influencer.css";

import { influencerNoteContent } from "./InfluencerAssets/InfluencerNoteContent";
import { influencerMessageContent } from "./InfluencerAssets/InfluencerMessagesContent";
import { GramChatsConst } from "./InfluencerAssets/InfluencerGramContent";
import { InfluencerCallContent } from "./InfluencerAssets/InfluencerCallContent";
import { InfluencerTheGramContent } from "./InfluencerAssets/InfluencerTheGramContent";
import { Chat_content } from "../../Components/MessageApp/MessagesInterfaces";
import InfluencerMap from "./InfluencerAssets/InfluencerMapContent/JoshPhone_Map.jpg";
import CallApp from "../../Components/CallApp/CallApp";
import { InfluencerPhotoContent } from "./InfluencerAssets/InfluencerPhotoContent";
import { recentSearches } from "./InfluencerAssets/InfluencerMapContent/InfluencerMapContent";

const Messages = lazy(() => import("../../Components/MessageApp/Messages"));
const Photos = lazy(() => import("../../Components/PhotosApp/Photos"));
const AppsMenu = lazy(() => import("../../Components/AppsMenu/AppsMenu"));
const NotesApp = lazy(() => import("../../Components/NotesApp/NotesApp"));
const TheGramApp = lazy(() => import("../../Components/TheGramApp/TheGramApp"));
const MapApp = lazy(() => import("../../Components/MapApp/Maps"));

function Influencer() {
  const [isLocked, setIsLocked] = useState(true);
  const [activeApp, setActiveApp] = useState("appsmenu");
  const [theGramNotifications, setTheGramNotifications] = useState(5);
  const [messages, setMessages] = useState(influencerMessageContent);
  const [theGramMessages, setTheGramMessages] = useState(GramChatsConst);
  const [messageNotifications, setMessageNotifications] = useState(2);

  const unlock = () => {
    setIsLocked(false);
  };

  const handleStateChange = (chat: Chat_content) => {
    const chatIndex = messages.findIndex(
      (message) => message.name === chat.name
    );
    const previousMessage = messages[chatIndex];
    if (previousMessage && !previousMessage.read) {
      const newMessages = [...messages];
      newMessages[chatIndex] = {
        ...newMessages[chatIndex],
        read: true,
      };
      setMessages(newMessages);
      setMessageNotifications(messageNotifications - 1);
    }
  };
  const handleGramStateChange = (chat: Chat_content) => {
    const chatIndex = theGramMessages.findIndex(
      (message) => message.name === chat.name
    );
    const previousMessage = theGramMessages[chatIndex];
    if (previousMessage && !previousMessage.read) {
      const newMessages = [...theGramMessages];
      newMessages[chatIndex] = {
        ...newMessages[chatIndex],
        read: true,
      };
      setTheGramMessages(newMessages);
      setTheGramNotifications(theGramNotifications - 1);
    }
  };
  const renderApp = () => {
    switch (activeApp) {
      case "messages":
        return (
          <Messages
            influencerMessageContent={messages}
            theGram={false}
            handleStateChange={handleStateChange}
          />
        );
      case "phone":
        return <CallApp callContent={InfluencerCallContent} />;
      case "photos":
        return <Photos albums={InfluencerPhotoContent} />;
      case "notes":
        return <NotesApp noteContent={influencerNoteContent} />;
      case "appsmenu":
        return (
          <AppsMenu
            isLocked={isLocked}
            setActiveApp={setActiveApp}
            theGramNotifications={theGramNotifications}
            messageNotifications={messageNotifications}
          />
        );

      case "thegram":
        return (
          <TheGramApp
            content={InfluencerTheGramContent}
            messages={theGramMessages}
            notifications={theGramNotifications}
            handleStateChange={handleGramStateChange}
          />
        );
      case "maps":
        return (
          <MapApp mapImage={InfluencerMap} recentSearches={recentSearches} />
        );
      default:
        return null;
    }
  };

  return (
    <div className="Mystery">
      <div className="phone-wrapper">
        <div className={`influencerscreen ${activeApp}`}>
          {isLocked ? (
            <div
              className={`lockscreen-container ${
                isLocked ? "visible" : "hidden"
              }`}
            >
              <LockScreen unlock={unlock} password={"190595"} />
            </div>
          ) : null}

          <Suspense
            fallback={
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                Loading...
              </div>
            }
          >
            {renderApp()}
          </Suspense>
          <div className="home-button-container"></div>
          <div
            className="home-button"
            onClick={() => setActiveApp("appsmenu")}
          ></div>
        </div>
      </div>
    </div>
  );
}

export default Influencer;
